import { SSOIdentifierEnum } from 'src/types/Corp';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';

type UseSsoIdentifierWrapperReturn = {
  ssoEnabled: boolean;
  ssoUniqueIdentifier: string;
};

export function useSsoIdentifierWrapper(): UseSsoIdentifierWrapperReturn {
  const { corpData } = useEmployeeFormContext();
  const { ssoEnabled, ssoIdentifier, ssoUniqueIdentifier } = corpData;

  return {
    ssoEnabled: ssoEnabled && ssoIdentifier === SSOIdentifierEnum.OTHER,
    ssoUniqueIdentifier,
  };
}
